import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { LineChartOutlined, FundOutlined } from '@ant-design/icons';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import StrategiesPage from './components/StrategiesPage';
import { PositionsAclDashboardValidationPage } from './aclSidecar/PositionsAclDashboardValidationPage';
import 'antd/dist/reset.css';
import './App.css';

const { Header, Content } = Layout;

// Simple mock data for demonstration
const mockOHLCData = [
  [Date.now() - 7 * 24 * 60 * 60 * 1000, 21000, 21100, 20900, 21050],
  [Date.now() - 6 * 24 * 60 * 60 * 1000, 21050, 21200, 21000, 21150],
  [Date.now() - 5 * 24 * 60 * 60 * 1000, 21150, 21250, 21100, 21200],
  [Date.now() - 4 * 24 * 60 * 60 * 1000, 21200, 21300, 21150, 21220],
  [Date.now() - 3 * 24 * 60 * 60 * 1000, 21220, 21350, 21180, 21280],
  [Date.now() - 2 * 24 * 60 * 60 * 1000, 21280, 21400, 21250, 21320],
  [Date.now() - 1 * 24 * 60 * 60 * 1000, 21320, 21450, 21300, 21380],
  [Date.now(), 21380, 21500, 21350, 21450]
];

const mockVolumeData = [
  [Date.now() - 7 * 24 * 60 * 60 * 1000, 1500000],
  [Date.now() - 6 * 24 * 60 * 60 * 1000, 1800000],
  [Date.now() - 5 * 24 * 60 * 60 * 1000, 1600000],
  [Date.now() - 4 * 24 * 60 * 60 * 1000, 1700000],
  [Date.now() - 3 * 24 * 60 * 60 * 1000, 1900000],
  [Date.now() - 2 * 24 * 60 * 60 * 1000, 2100000],
  [Date.now() - 1 * 24 * 60 * 60 * 1000, 1950000],
  [Date.now(), 2200000]
];

function App() {
  // Original F&O Chart Component
  const FOChart = () => {
    const chartOptions = {
    chart: {
      type: 'candlestick',
      backgroundColor: '#1f1f1f',
      height: 400
    },
    title: {
      text: 'F&O Underlying Chart - NIFTY',
      style: { color: '#ffffff' }
    },
    xAxis: {
      type: 'datetime',
      labels: { style: { color: '#8c8c8c' } }
    },
    yAxis: [{
      title: { text: 'Price', style: { color: '#8c8c8c' } },
      labels: { style: { color: '#8c8c8c' } },
      height: '70%'
    }, {
      title: { text: 'Volume', style: { color: '#8c8c8c' } },
      labels: { style: { color: '#8c8c8c' } },
      top: '75%',
      height: '25%'
    }],
    series: [{
      type: 'candlestick',
      name: 'NIFTY',
      data: mockOHLCData,
      yAxis: 0,
      upColor: '#52c41a',
      color: '#ff4d4f'
    }, {
      type: 'column',
      name: 'Volume',
      data: mockVolumeData,
      yAxis: 1,
      color: '#595959'
    }],
    legend: {
      enabled: true,
      itemStyle: { color: '#ffffff' }
    },
    plotOptions: {
      candlestick: {
        upColor: '#52c41a',
        color: '#ff4d4f'
      }
    }
  };

    return (
      <div className="App">
        <div className="fo-layout">
        {/* Controls Bar */}
        <div className="fo-controls">
          <div className="title">F&O Multi-Panel Chart</div>
          <div className="controls-group">
            <select className="control-select">
              <option>NIFTY 26DEC24</option>
              <option>BANKNIFTY 26DEC24</option>
              <option>FINNIFTY 26DEC24</option>
            </select>
            <select className="control-select">
              <option>5m</option>
              <option>1m</option>
              <option>15m</option>
              <option>30m</option>
              <option>1h</option>
            </select>
            <button className="control-button">Reset View</button>
          </div>
          <div className="connection-status">
            <span className="status-indicator"></span>
            ✅ Highcharts Loaded Successfully
          </div>
        </div>

        {/* Left Panel - Call Options */}
        <div className="fo-left-panel">
          <div className="panel-header">Options Chain - Calls (LP)</div>
          <div className="panel-content">
            <div>📊 Call Options Data</div>
            <div className="demo-table">
              <table>
                <thead>
                  <tr>
                    <th>Strike</th>
                    <th>LTP</th>
                    <th>Volume</th>
                    <th>OI</th>
                    <th>Delta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>21000</td><td>₹485</td><td>12.5K</td><td>45.8K</td><td>0.75</td></tr>
                  <tr><td>21100</td><td>₹420</td><td>18.2K</td><td>52.3K</td><td>0.68</td></tr>
                  <tr><td>21200</td><td>₹365</td><td>15.7K</td><td>38.9K</td><td>0.62</td></tr>
                  <tr><td>21300</td><td>₹315</td><td>22.1K</td><td>67.4K</td><td>0.55</td></tr>
                  <tr><td>21400</td><td>₹270</td><td>19.8K</td><td>71.2K</td><td>0.48</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Underlying Chart - Master Hub */}
        <div className="fo-underlying-chart">
          <div className="panel-header">Underlying Chart - NIFTY (UC) - Master Hub</div>
          <div className="chart-container">
            <HighchartsReact
              highcharts={Highcharts}
              constructorType={'stockChart'}
              options={chartOptions}
            />
          </div>
        </div>

        {/* Right Tabs - Instrument Analysis */}
        <div className="fo-right-tabs">
          <div className="panel-header">Put Options Chain (RP)</div>
          <div className="panel-content">
            <div>📊 Put Options Data</div>
            <div className="demo-table">
              <table>
                <thead>
                  <tr>
                    <th>Strike</th>
                    <th>LTP</th>
                    <th>Volume</th>
                    <th>OI</th>
                    <th>Delta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr><td>21000</td><td>₹65</td><td>8.5K</td><td>35.8K</td><td>-0.25</td></tr>
                  <tr><td>21100</td><td>₹85</td><td>12.2K</td><td>42.3K</td><td>-0.32</td></tr>
                  <tr><td>21200</td><td>₹115</td><td>9.7K</td><td>28.9K</td><td>-0.38</td></tr>
                  <tr><td>21300</td><td>₹155</td><td>16.1K</td><td>57.4K</td><td>-0.45</td></tr>
                  <tr><td>21400</td><td>₹205</td><td>13.8K</td><td>61.2K</td><td>-0.52</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Bottom Panels */}
        <div className="fo-left-spider">
          <div className="panel-header">Call Greeks Spider</div>
          <div className="panel-content">
            <div className="spider-chart">
              <div className="spider-line"></div>
              <div className="spider-line"></div>
              <div className="spider-line"></div>
              <div className="spider-line"></div>
              <div className="spider-line"></div>
            </div>
            <div style={{fontSize: '10px'}}>Delta • Gamma • Theta • Vega • IV</div>
          </div>
        </div>

        <div className="fo-bottom-panel">
          <div className="panel-header">Moneyness Analysis (BP)</div>
          <div className="panel-content">
            <div>🔥 Heatmap Visualization</div>
            <div className="heatmap-placeholder">
              Moneyness Heatmap<br/>
              ATM | OTM1-10 | ITM1-10
            </div>
          </div>
        </div>

        <div className="fo-right-spider">
          <div className="panel-header">Put Greeks Spider</div>
          <div className="panel-content">
            <div className="spider-chart">
              <div className="spider-line"></div>
              <div className="spider-line"></div>
              <div className="spider-line"></div>
              <div className="spider-line"></div>
              <div className="spider-line"></div>
            </div>
            <div style={{fontSize: '10px'}}>Put Greeks Radar</div>
          </div>
        </div>
      </div>
    </div>
    );
  };

  // Main App with routing
  return (
    <Router>
      <Layout style={{ minHeight: '100vh', backgroundColor: '#141414' }}>
        <Header style={{ backgroundColor: '#001529', padding: '0 20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <div style={{ 
              color: '#ffffff', 
              fontSize: '18px', 
              fontWeight: 'bold', 
              marginRight: '40px' 
            }}>
              StocksBlitz
            </div>
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={['strategies']}
              style={{ backgroundColor: 'transparent', borderBottom: 'none' }}
            >
              <Menu.Item key="fo-charts" icon={<LineChartOutlined />}>
                <Link to="/">F&O Charts</Link>
              </Menu.Item>
              <Menu.Item key="strategies" icon={<FundOutlined />}>
                <Link to="/strategies">Strategies</Link>
              </Menu.Item>
            </Menu>
          </div>
        </Header>
        
        <Content style={{ backgroundColor: '#141414' }}>
          <Routes>
            <Route path="/" element={<FOChart />} />
            <Route path="/strategies" element={<StrategiesPage />} />
            <Route
              path="/validation/positions-acl-dashboard"
              element={<PositionsAclDashboardValidationPage />}
            />
          </Routes>
        </Content>
      </Layout>
    </Router>
  );
}

export default App;
